import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { useEffect } from 'react';
import classNames from 'classnames';
import { IconPlay } from '@/features/icons';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { handleImageError } from '@/utils/image-error';
import { desktopNavigationContainerHeight, desktopNavigationVisibleItemsCount } from './constant';
import { DesktopNavigationButtonHandler } from './desktop-navigation-button-handler';
import { generateImageAlt } from '../utils/generate-image-alt';
import { useGallaryItems } from '../utils/use-gallary-items';
import { SliderWheelController } from '../utils/wheel-controler';
interface Props {
  activeIndex: number;
  onActiveIndexChange?: (index: number) => void;
  numberOfVisibleItems?: number;
}
const DesktopGalleryNavigation = ({
  onActiveIndexChange,
  activeIndex
}: Props) => {
  const {
    data
  } = usePDPData();
  const {
    activeVariant
  } = useVariantContextValues('pdp');
  const {
    thumbnails
  } = useGallaryItems('pdp');
  const totalCount = thumbnails.length;
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: activeIndex ?? 0,
    slides: {
      perView: desktopNavigationVisibleItemsCount,
      spacing: 8,
      origin: 'auto'
    },
    vertical: true,
    mode: 'free',
    rubberband: false
  }, [SliderWheelController]);
  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.moveToIdx(activeIndex);
  }, [activeIndex, instanceRef]);
  if (!thumbnails.length) return <div className='h-full w-11' />;
  return <div className='hidden h-full gap-4 lg:flex' data-sentry-component="DesktopGalleryNavigation" data-sentry-source-file="desktop-navigation.tsx">
            <div className='flex h-full w-11 flex-col items-center'>
                {totalCount > 5 && <DesktopNavigationButtonHandler direction='up' onActiveIndexChange={onActiveIndexChange} activeIndex={activeIndex} instanceRef={instanceRef} totalCount={totalCount} />}

                <div ref={sliderRef} className='keen-slider hide-scrollbar flex w-full flex-col justify-center overflow-hidden pt-1' style={{
        height: desktopNavigationContainerHeight
      }}>
                    {thumbnails.map(({
          id,
          imageUrl,
          isVideo
        }, index) => {
          const isSelected = activeIndex === index;
          const imageSize = isSelected ? 38 : 40;
          return <button key={id} type='button' onClick={() => onActiveIndexChange && onActiveIndexChange(index)} className={classNames('keen-slider__slide flex !h-[40px] !min-h-[40px] !w-[40px] !min-w-[40px] items-center justify-center overflow-hidden rounded border', isSelected ? 'border-surface-solid-0 outline outline-2 outline-text-black' : 'border-transparent')}>
                                <div className={classNames('relative', {
              'bg-surface-scrim-black': isVideo
            })}>
                                    <img alt={generateImageAlt(index, data, activeVariant || undefined)} src={`${imageUrl}?w=34` || ''} className={classNames('aspect-square max-w-none rounded', isSelected ? 'h-9 w-9' : 'h-9.5 w-9.5')} onError={handleImageError} loading={index > 5 && !PUBLIC_IS_BOT ? 'lazy' : undefined} width={imageSize} height={imageSize} />

                                    {isVideo && <IconPlay className='absolute right-1/2 top-1/2 h-6 w-6 -translate-y-1/2 translate-x-1/2 text-text-white' />}
                                </div>
                            </button>;
        })}
                </div>

                {totalCount > 5 && <DesktopNavigationButtonHandler direction='down' onActiveIndexChange={onActiveIndexChange} activeIndex={activeIndex} instanceRef={instanceRef} totalCount={totalCount} />}
            </div>
        </div>;
};
export default DesktopGalleryNavigation;